import { topMatchProps } from '../../Templates/Assessment/Assessment';
import { Tag } from 'carbon-components-react';
import { TranslationFunction } from 'src/common/hooks/widgets/useTranslation';

type topMatchDataProps = {
  data: topMatchProps;
  que5Value: string;
  que6Value: string;
  useTranslation: TranslationFunction;
};

const TopMatch = ({
  data,
  que5Value,
  que6Value,
  useTranslation,
}: topMatchDataProps) => {
  const isMTDIncluded = () => {
    return que5Value === 'Yes';
  };

  const isRemoteAccessIncluded = () => {
    return que6Value === 'Remote access';
  };

  return (
    <div className="topmatch_comp">
      <div className="tm-intro">{useTranslation('top_match')}</div>
      <div className="page_heading_3 tm-mt">{data.title}</div>
      <div className="page_body mt-8">{data.shortDesc}</div>
      <div>
        {(isMTDIncluded() || isRemoteAccessIncluded()) && (
          <span className="selection-state">{useTranslation('include')}</span>
        )}
        {isMTDIncluded() && (
          <Tag
            type="purple"
            size="md"
            disabled={false}
            filter={false}
            style={{ marginLeft: '5px' }}
          >
            {useTranslation('mtd')}
          </Tag>
        )}
        {isRemoteAccessIncluded() && (
          <Tag
            type="purple"
            size="md"
            disabled={false}
            filter={false}
            style={{ marginLeft: '5px' }}
          >
            {useTranslation('remote_access')}
          </Tag>
        )}
      </div>
    </div>
  );
};

export default TopMatch;
